export const defaultState = {
	initialized: false,
	total: {
		currency_prefix: null,
		currency_suffix: 'TL',
		price: 0,
		price_formatted: '0',
		old_price: null,
		old_price_formatted: null,
	},
	items: [],
	indexedItems: {},
};
